export const CLOSE = 'baq/sideNav/bulkEditDiscountsDrawer/CLOSE';
export const OPEN = 'baq/sideNav/bulkEditDiscountsDrawer/OPEN';
